export { MeusExamesSolicitados } from './MeusExamesSolicitados'
